import { createFileRoute } from '@tanstack/react-router';
import { useGetSpace, useGetSubSpaces } from '@onesource/services';
import { SpaceType } from '@onesource/schemas';
import { ModulesTabContent } from '../../../../../../features/community-hub/components/modules-tab-content';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

/**
 * Space Modules Route
 * Path: /community-hub/spaces/:id/modules
 * Shows all CONTENT sub-spaces in a split view
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/modules/')({
  component: SpaceModulesRoute,
});

function SpaceModulesRoute() {
  const { id } = Route.useParams();
  const { data: space, isLoading: isLoadingSpace, error: spaceError } = useGetSpace(id);
  const { data: subSpaces, isLoading: isLoadingSubSpaces } = useGetSubSpaces(id);

  if (isLoadingSpace || isLoadingSubSpaces) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress />
      </Box>
    );
  }

  if (spaceError) {
    return <Alert severity="error">Failed to load space: {spaceError.message}</Alert>;
  }

  if (!space) {
    return <Alert severity="error">Space not found</Alert>;
  }

  // Filter to only CONTENT type sub-spaces (modules)
  const contentSubSpaces = subSpaces?.filter(s => s.spaceType === SpaceType.CONTENT) || [];

  return <ModulesTabContent subSpaces={contentSubSpaces} parentSpace={space} />;
}
